import React, { useRef } from 'react';
import { array, func, object } from 'prop-types';
import useOutsideOfElement from '../custom-hooks/useOutsideOfElement';

import MobileAllPlaces from './MobileAllPlaces';
import Locations from './Locations'

function FilteredMobile({ filtered, seeAllHotels, setHideDropdown, searchKey, allPlaces }) {
  const autocompleteRef = useRef(null);

  useOutsideOfElement({
    element: autocompleteRef,
    hook: setHideDropdown,
    value: true
  });

  if (filtered.length > 0) {
    return (
      <div ref={autocompleteRef} className="autocomplete-suggestions find-a-hotel-autocomplete">
        <div className="autocomplete-block">
          <Locations searchKey={searchKey} allPlaces={allPlaces} classForMobile={true}/>
          <MobileAllPlaces
            className="autocomplete-suggestion suggestion"
            filtered={filtered}
          />
        </div>
        <div className="autocomplete-block">
          <div className="autocomplete-see-all">
            <button onClick={seeAllHotels}>See all hotels</button>
          </div>
        </div>
      </div>
    );
  } else return null;
}

FilteredMobile.propTypes = {
  allPlaces: array.isRequired,
  filtered: array.isRequired, 
  Locations: object.isRequired,
  seeAllHotels: func.isRequired
};

export default FilteredMobile;
